"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const KioskAppHeader_1 = __importDefault(require("../Header/KioskAppHeader"));
const ActivateCard_1 = __importDefault(require("./KeycardPages/ActivateCard"));
const CardActivationSuccessfull_1 = __importDefault(require("./KeycardPages/CardActivationSuccessfull"));
const CardActivationFailed_1 = __importDefault(require("./KeycardPages/CardActivationFailed"));
const ProcessCompleted_1 = __importDefault(require("./KeycardPages/ProcessCompleted"));
const Wrapper = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1102;
  background: #fff;
  height: 100%;
  width: 100%;
  overflow: auto;
`;
const initialDisplayData = {
    image: "https://experimental.hotel-mssngr.com/assets/guest_journey/key_card_encode.svg?1",
    texts: {
        text: "Take a card from the drawer and place it over the encoder to activate it.",
        startActivationButton: "Start activation",
        activationLoadingTitle: "Activating cards …",
        activationLoadingBody: "Do not move the cards until the activation is successful.",
        activationCancelTitle: "Close form",
        activationCancelBody: "If you close the form, none of the information you've entered will be saved. You can either continue checking in through the kiosk or go to the reception.",
        activationCancelConfirm: "Close form",
        activationCancelContinue: "Continue",
    },
    status: "success",
};
const defaultError = i18n_js_1.default.t("guest_journey_an_error_has_occured_kiosk");
const KeycardActivationFlow = ({ baseUrl, history, currentLocale }) => {
    const [showDiscardFormDialog, setShowDiscardFormDialog] = (0, react_1.useState)(false);
    const [showDefaultError, setShowDefaultError] = (0, react_1.useState)(false);
    const [displayData, setDisplayData] = (0, react_1.useState)(initialDisplayData);
    const [statusScreen, setStatusScreen] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const token = localStorage.getItem("kioskUserToken");
        apiService_1.default
            .getKeyCards(currentLocale, token)
            .then((data) => {
            if (data.status === "success") {
                setDisplayData(data);
            }
            else {
                setShowDefaultError(true);
            }
        })
            .catch(() => {
            setShowDefaultError(true);
        });
    }, []);
    const handleCancelBtn = () => {
        const keycardActivationProcessCompleted = window.location.pathname.includes("/guest_journey/kiosk/keycard_activation_flow/process_completed");
        if (keycardActivationProcessCompleted) {
            history.push(`${baseUrl}/guest_journey/kiosk`);
            return;
        }
        setShowDiscardFormDialog(true);
    };
    const handleDialogClick = (action) => {
        if (action === "discard") {
            history.push(`${baseUrl}/guest_journey/kiosk`);
        }
        else {
            setShowDiscardFormDialog(false);
        }
    };
    const headerText = i18n_js_1.default.t("key_card_retrieval_header_navigation_bar");
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(KioskAppHeader_1.default, { title: headerText, navAction: handleCancelBtn }),
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: `${baseUrl}/guest_journey/kiosk/keycard_activation_flow/activate_card` },
                react_1.default.createElement(ActivateCard_1.default, { displayData: displayData, setStatusScreen: setStatusScreen, setShowDefaultError: setShowDefaultError })),
            react_1.default.createElement(react_router_dom_1.Route, { path: `${baseUrl}/guest_journey/kiosk/keycard_activation_flow/activation_successfull` },
                react_1.default.createElement(CardActivationSuccessfull_1.default, { statusData: statusScreen })),
            react_1.default.createElement(react_router_dom_1.Route, { path: `${baseUrl}/guest_journey/kiosk/keycard_activation_flow/activation_failed` },
                react_1.default.createElement(CardActivationFailed_1.default, { statusData: statusScreen })),
            react_1.default.createElement(react_router_dom_1.Route, { path: `${baseUrl}/guest_journey/kiosk/keycard_activation_flow/process_completed` },
                react_1.default.createElement(ProcessCompleted_1.default, { setShowDefaultError: setShowDefaultError }))),
        react_1.default.createElement(material_1.Dialog, { "data-testid": "discard-form", open: showDiscardFormDialog, keepMounted: true, onClose: () => { }, "aria-describedby": "alert-dialog-slide-description" },
            react_1.default.createElement(material_1.DialogTitle, null, displayData.texts && displayData.texts.activationCancelTitle),
            react_1.default.createElement(material_1.DialogContent, null, displayData.texts && displayData.texts.activationCancelBody),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: handleDialogClick }, displayData.texts && displayData.texts.activationCancelContinue),
                react_1.default.createElement(material_1.Button, { "data-testid": "confirm-discard", onClick: () => handleDialogClick("discard") }, displayData.texts && displayData.texts.activationCancelConfirm))),
        react_1.default.createElement(material_1.Dialog, { "data-testid": "general-error", open: showDefaultError, keepMounted: true, "aria-describedby": "alert-dialog-slide-description" },
            react_1.default.createElement(material_1.DialogContent, null, defaultError),
            react_1.default.createElement(material_1.DialogActions, { sx: {
                    justifyContent: "center",
                } },
                react_1.default.createElement(material_1.Button, { onClick: () => {
                        history.push(`${baseUrl}/guest_journey/kiosk`);
                    } },
                    " ",
                    i18n_js_1.default.t("kiosk_refresh"))))));
};
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(KeycardActivationFlow));
